var _path, _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFilter = function SvgFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#0E0F11",
    strokeLinecap: "round",
    d: "M4.5 8.5h15M4.5 14.5h15"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 8.5,
    r: 2,
    fill: "#fff",
    stroke: "#0E0F11"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 14.5,
    r: 2,
    fill: "#fff",
    stroke: "#0E0F11"
  })));
};
export { SvgFilter as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgImRhdGE6aW1hZ2Uvc3ZnK3htbDtiYXNlNjQsUEhOMlp5QjNhV1IwYUQwaU1qUWlJR2hsYVdkb2REMGlNalFpSUhacFpYZENiM2c5SWpBZ01DQXlOQ0F5TkNJZ1ptbHNiRDBpYm05dVpTSWdlRzFzYm5NOUltaDBkSEE2THk5M2QzY3Vkek11YjNKbkx6SXdNREF2YzNabklqNEtJQ0E4YkdsdVpTQjRNVDBpTkM0MUlpQjVNVDBpT0M0MUlpQjRNajBpTVRrdU5TSWdlVEk5SWpndU5TSWdjM1J5YjJ0bFBTSWpNRVV3UmpFeElpQnpkSEp2YTJVdGJHbHVaV05oY0QwaWNtOTFibVFpTHo0S0lDQThiR2x1WlNCNE1UMGlOQzQxSWlCNU1UMGlNVFF1TlNJZ2VESTlJakU1TGpVaUlIa3lQU0l4TkM0MUlpQnpkSEp2YTJVOUlpTXdSVEJHTVRFaUlITjBjbTlyWlMxc2FXNWxZMkZ3UFNKeWIzVnVaQ0l2UGdvZ0lEeGphWEpqYkdVZ1kzZzlJakUxTGpVaUlHTjVQU0k0TGpVaUlISTlJaklpSUdacGJHdzlJbmRvYVhSbElpQnpkSEp2YTJVOUlpTXdSVEJHTVRFaUx6NEtJQ0E4WTJseVkyeGxJR040UFNJNExqVWlJR041UFNJeE5DNDFJaUJ5UFNJeUlpQm1hV3hzUFNKM2FHbDBaU0lnYzNSeWIydGxQU0lqTUVVd1JqRXhJaTgrQ2p3dmMzWm5QZ289Ig==";